import React from 'react';
import ForgotPasswordForm from 'modules/ForgotPassword/components/ForgotPasswordForm';
import usePageMeta from '../hooks/usePageMeta';

const ForgotPassword: React.FC = (): JSX.Element => {
  usePageMeta({
    title: 'Forgot Password — BoostHiring',
    description: 'Reset your BoostHiring account password.',
    noindex: true,
  });

  return <ForgotPasswordForm />;
};

export default ForgotPassword;
